import { Component } from '@angular/core';

@Component({
  selector: 'app-do-not-modify-banner',
  templateUrl: './do-not-modify-banner.component.html',
  styleUrls: ['./do-not-modify-banner.component.scss']
})

export class DoNotModifyBannerComponent {
  constructor() { }
}
